/* eslint-disable react/prop-types */
import React from 'react';
import {
  Form,
  Row,
  Col,
  Input,
} from 'antd';
import {
  INCIDENCIA_PAGOLABORAL,
  INCIDENCIA_INCAPACIDAD,
  INCIDENCIA_VACACIONES,
  ESTATUS_INACTIVO,
  INCIDENCIA_AUSENTISMO,
} from 'utils/constants';
import Select from '../../Select';

const { TextArea } = Input;

// eslint-disable-next-line react/prop-types
const IncidenciasGenerales = ({
  form,
  selectedRowKeys,
  rules,
  estados,
  percepciones,
  catsatPercepciones,
  incapacidades,
  tiposIncidencias,
  tiposIncidenciasUnidades,
  tipoIncidencia,
  setTipoIncidencia,
  setSelectedPercepciones,
  disabled,
  setVisibleConfirmInactivo,
  disableOnTipoIncidencia,
  setDisableOnTipoIncidencia,
  setAplicaCatalogosAdicionales,
}) => {
  const onChangeTipoIncidencia = (value) => {
    setTipoIncidencia(value);
    setSelectedPercepciones(value);
    form.resetFields(['percepcion', 'catsat_percepcion', 'tipo_incapacidad_nomina']);
    // if (value === INCIDENCIA_AUSENTISMO
    //   || value === INCIDENCIA_VACACIONES) {
    //   setDisableOnTipoIncidencia(true);
    // } else {
    setDisableOnTipoIncidencia(false);
    // }
    /* if (value === INCIDENCIA_INCAPACIDAD) {
      setAplicaCatalogosAdicionales(false);
      form.setFieldsValue({
        aparece_en_recibo_de_nomina: false,
        aplica_pago: true,
        aplica_descuento: true,
        se_suspende_el_pago_de_sueldo: false,
        aplica_restar_de_dias_laborados: false,
        cuenta_como_dias_laborados: false,
        aplica_porcentaje_de_sueldo_a_pagar: false,
        requiere_datos_informativos: false,
        aplica_catalogos_adicionales: false,
        aplica_categorias_de_incapacidades: false,
        aplica_subcategorias_de_incapacidades: false,
        aplica_porcentaje_de_sueldo: false,
        aplica_motivos_de_permisos: false,
      });
    } else { */
    setAplicaCatalogosAdicionales(true);
    form.setFieldsValue({
      aparece_en_recibo_de_nomina: false,
      aplica_pago: false,
      aplica_descuento: false,
      se_suspende_el_pago_de_sueldo: false,
      aplica_restar_de_dias_laborados: false,
      cuenta_como_dias_laborados: false,
      aplica_porcentaje_de_sueldo_a_pagar: false,
      requiere_datos_informativos: false,
    });
    // }
  };
  const onChangePercepcion = (value) => {
    if (!percepciones || !catsatPercepciones) return;
    const selectedPercepcion = percepciones.find((p) => p.id === value);

    if (!selectedPercepcion) {
      form.setFieldsValue({ catsat_percepcion: null });
      return;
    }

    const matchingSATPercepcion = catsatPercepciones.find(
      (p) => p.id === selectedPercepcion.catsat_percepcion,
    );

    form.setFieldsValue({
      catsat_percepcion: matchingSATPercepcion?.id || null,
    });
  };

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clave"
            rules={rules.clave}
            label="Clave"
            hasFeedback
          >
            <Input
              allowClear
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="concepto"
            label="Concepto"
            rules={rules.required}
            hasFeedback
          >
            <Input
              allowClear
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="fundamento"
            label="Fundamento"
            hasFeedback
          >
            <Input
              allowClear
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_de_incidencia"
            label="Tipo de Incidencia"
            rules={rules.required}
            hasFeedback
          >
            <Select
              dataSource={tiposIncidencias}
              onChange={onChangeTipoIncidencia}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="percepcion"
            label="Percepción"
            rules={
              tipoIncidencia === INCIDENCIA_PAGOLABORAL
                || tipoIncidencia === INCIDENCIA_INCAPACIDAD ? rules.required : null
            }
            hasFeedback
          >
            <Select
              dataSource={percepciones.filter((p) => p.estados_globales === 4)}
              render={(value) => `${value?.clave} - ${value?.descripcion}`}
              disabled={disabled || disableOnTipoIncidencia}
              onChange={onChangePercepcion}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="catsat_percepcion"
            label="Tipo de Percepción del SAT"
            rules={
              tipoIncidencia === INCIDENCIA_PAGOLABORAL
                || tipoIncidencia === INCIDENCIA_INCAPACIDAD ? rules.required : null
            }
            hasFeedback
          >
            <Select
              dataSource={catsatPercepciones}
              render={(value) => `${value?.clave} - ${value?.descripcion}`}
              disabled={disabled || disableOnTipoIncidencia}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_incapacidad_nomina"
            label="Tipo de Incapacidad SAT"
            rules={tipoIncidencia === INCIDENCIA_INCAPACIDAD ? rules.required : null}
            hasFeedback
          >
            <Select
              dataSource={incapacidades}
              render={(val) => `${val?.clave} - ${val?.descripcion}`}
              disabled={tipoIncidencia !== INCIDENCIA_INCAPACIDAD || disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_de_incidencia_unidad"
            label="Unidad de Incidencia"
            rules={rules.required}
            hasFeedback
          >
            <Select
              dataSource={tiposIncidenciasUnidades}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estados_globales"
            label="Estatus"
            rules={rules.required}
            hasFeedback
            initialValue={1}
          >
            <Select
              labelProp="descripcion"
              keyProp="id"
              dataSource={estados}
              disabled={selectedRowKeys.length <= 0 || disabled}
              onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            name="observaciones"
            label="Observaciones"
            hasFeedback
          >
            <TextArea disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default IncidenciasGenerales;
